export const DOMAIN_NAME = "imbaweb.com"

export const FORM_MODE = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  READ_ONLY: 'READ_ONLY'
}

export const DATA_TYPE = {
  'STRING': 'STRING',
  'UUID': 'UUID',
  'TEXT': 'TEXT',
  'BOOLEAN': 'BOOLEAN',
  'INTEGER': 'INTEGER',
  'SEQUENCE': 'SEQUENCE',
  'DECIMAL': 'DECIMAL',
  'MONEY': 'MONEY',
  'DATETIME': 'DATETIME',
  'DATE': 'DATE',
  'LIST_GROUP': 'LIST_GROUP',
  'MODEL': 'MODEL',
  'JSON': 'JSON',
  'COMPOSITE': 'COMPOSITE'
}

export const DATA_TYPE_TO_GRAPHQL = {
  'STRING': 'String',
  'UUID': 'String',
  'TEXT': 'String',
  'BOOLEAN': 'Boolean',
  'INTEGER': 'Int',
  'SEQUENCE': 'Int',
  'DECIMAL': 'Float',
  'MONEY': 'Float',
  'DATETIME': 'DateTime',
  'DATE': 'Date',
  'LIST_GROUP': 'String',
  'MODEL': 'String',
  'JSON': 'String',
  'COMPOSITE': 'String'
}

export const TENANT_NAME = window.TENANT_NAME

// ---------- IMAGE BUCKET  ---------- 

export const GLOBAL_BUCKET = `https://storage.googleapis.com/images.imbaweb.com`

export const TENANT_BUCKET = `https://storage.googleapis.com/${TENANT_NAME}-images.imbaweb.com`

// ---------- DESIGNER MODE  ---------- 

export const DESIGNER_MODE = false

// ---------- LANGUAGE ---------- 

// export const LANGUAGE = {
//   en: { nativeName: 'English' },
//   bm: { nativeName: 'Malay' },
//   zh: { nativeName: '中文' }
// }

// ---------- PAGE ---------- 

export const PAGE_DATA = {

  "HOME": {
    name: "home",
    url: "/",
    value: 'MALL_HOME'
  },
  "LOGIN": {
    name: "login",
    url: "/login",
    value: 'MALL_LOGIN'
  },

  "REGISTER": {
    name: "register",
    url: "/register",
    value: 'MALL_REGISTER'
  },

  "SHOP": {
    name: "shop",
    url: "/shop",
    value: 'MALL_SHOP'
  },

  "HELP": {
    name: "help",
    url: "/help",
    value: 'MALL_HELP'
  },

  "CONTACT_US": {
    name: "contact_us",
    url: "/contact-us",
    value: 'MALL_CONTACT_US'
  },

  "HOW_IT_WORK": {
    name: "how_it_work",
    url: "/how_it_work",
    value: 'MALL_HOW_IT_WORK'
  },
  "SHOPPING_CART": {
    name: "shopping_cart",
    url: "/shopping_cart",
    value: 'MALL_SHOPPING_CART'
  },

  "MY_PROFILE": {
    name: "my_profile",
    url: "/my-profile",
    value: 'MALL_MY_PROFILE'
  },
  "USER_INFO": {
    name: "user_info",
    url: "/my_account/user_info",
    value: 'MALL_USER_INFO'
  },
  "ORDER_HISTORY": {
    name: "order_history",
    url: "/my_account/order_history",
    value: 'MALL_ORDER_HISTORY'
  },
}
// ---------- HEADER MENU ---------- 

export const HEADER_MENU_DATA = {

  "HOME": {
    name: "home",
    icon: `${TENANT_BUCKET}/icon/mall_menu_home.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/mall_menu_home_active.png`,
    mobileShow: true,
    url: "/",
  },


  "PROMOTION": {
    name: "promotion",
    icon: `${TENANT_BUCKET}/icon/mall_menu_promotion.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/mall_menu_promotion_active.png`,
    mobileShow: true,
    url: "/promotions",
  },

  "SHOP": {
    name: "shop",
    icon: `${TENANT_BUCKET}/icon/mall_menu_shop.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/mall_menu_shop_active.png`,
    mobileShow: true,
    url: "/shop",
  }
  ,
  "HOW_IT_WORK": {
    name: "how_it_work",
    icon: `${TENANT_BUCKET}/icon/mall_menu_how_it_work.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/mall_menu_how_it_work_active.png`,
    mobileShow: true,
    url: "/how_it_work",
  }
  ,
  "WEBSITE": {
    name: "back_to_website",
    icon: `${TENANT_BUCKET}/icon/mall_menu_website.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/mall_menu_website_active.png`,
    mobileShow: true,
    url: "/website",
  }
}

// ---------- FOOTER MENU ---------- 

export const FOOTER_MENU_DATA = {

  "ABOUT_US": {
    name: "about_us",
    mobileShow: true,
    url: "/help#about-us",
  },

  "TNC": {
    name: "tnc",
    mobileShow: true,
    url: "/help#term-and-conditions",
  },

  "FAQ": {
    name: "faq",
    mobileShow: true,
    url: "/help#faq",
  },

  "HOW_TO_DEPOSIT": {
    name: "how_to_deposit",
    mobileShow: true,
    url: "/help#how-to-deposit",
  },

  "HOW_TO_TRANSFER": {
    name: "how_to_transfer",
    mobileShow: true,
    url: "/help#how-to-transfer",
  },

  "HOW_TO_WITHDRAW": {
    name: "how_to_withdrawal",
    mobileShow: true,
    url: "/help#how-to-withdraw",
  },

  "CONTACT_US": {
    name: "contact_us",
    mobileShow: true,
    url: "/contact-us",
  },

  "VIP": {
    name: "vip",
    mobileShow: true,
    url: "/vip",
  }
}

// ---------- GAME MENU ---------- 

export const GAME_MENU_DATA = {

  "SL": {
    gameType: 'SL',
    name: "slots",
    icon: `${TENANT_BUCKET}/icon/game_menu_slot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_slot_active.png`,
    url: "/slots",
  },

  "LC": {
    gameType: 'LC',
    name: "live_casino",
    icon: `${TENANT_BUCKET}/icon/game_menu_casino.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_casino_active.png`,
    url: "/live-casino",
  },

  "APP": {
    gameType: 'APP',
    name: "mobile_slot",
    icon: `${TENANT_BUCKET}/icon/game_menu_mslot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mslot_active.png`,
    url: "/mobile-slots",
  },

  "ES": {
    gameType: 'ES',
    name: "e-sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_esport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_esport_active.png`,
    url: "/esport",
  },

  "SB": {
    gameType: 'SB',
    name: "sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_sport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_sport_active.png`,
    url: "/sports",
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    icon: `${TENANT_BUCKET}/icon/game_menu_lottery.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_lottery_active.png`,
    url: "/lottery",
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    icon: `${TENANT_BUCKET}/icon/game_menu_fishing.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_fishing_active.png`,
    url: "/fishing",
  },

  "CB": {
    gameType: 'CB',
    name: "boardgame",
    icon: `${TENANT_BUCKET}/icon/game_menu_boardgame.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_boardgame_active.png`,
    url: "/board-game",
  },

  "PK": {
    gameType: 'PK',
    name: "poker",
    icon: `${TENANT_BUCKET}/icon/game_menu_poker.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_poker_active.png`,
    url: "/poker",
  }
  ,
  "MG": {
    gameType: 'MG',
    name: "mini_game",
    icon: `${TENANT_BUCKET}/icon/game_menu_mini_game.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mini_game_active.png`,
    url: "/mini-game",
  },
  "OT": {
    gameType: 'OT',
    name: "others",
    icon: `${TENANT_BUCKET}/icon/game_menu_others.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_others_active.png`,
    url: "/others",
  }


}

// ---------- SLOT ---------- 

export const SLOT_GAME_TYPE = {

  "ALL": {
    gameType: 'ALL',
    name: "all",
    label: 'gameType_all'
  },

  "SL": {
    gameType: 'SL',
    name: "slots",
    label: 'gameType_slots'
  },

  "AR": {
    gameType: 'AR',
    name: "arcade",
    label: 'gameType_arcade'
  },

  "LC": {
    gameType: 'LC',
    name: "table",
    label: 'gameType_table'
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    label: 'gameType_fishing'
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    label: 'lottery'
  },

  "OT": {
    gameType: 'OT',
    name: "other",
    label: 'other'
  },

  "BG": {
    gameType: 'BG',
    name: "bingo",
    label: 'bingo'
  },

  "FG": {
    gameType: 'FG',
    name: "featured games",
    label: 'featured games'
  },

  "FK": {
    gameType: 'FK',
    name: "funky",
    label: 'funky'
  },

  "MP": {
    gameType: 'MP',
    name: "multiplayer",
    label: 'multiplayer'
  },

  "SC": {
    gameType: 'SC',
    name: "scratch cards",
    label: 'scratch cards'
  },

  "SP": {
    gameType: 'SP',
    name: "single player",
    label: 'single player'
  },

  "TB": {
    gameType: 'TB',
    name: "table",
    label: 'gameType_table'
  },
}

// ---------- WALLET MENU ---------- 

export const WALLET_MENU_DATA =
{
  // funds: [{
  //   id: "0",
  //   name: "deposit",
  //   mobileName: 'deposit',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit_active.png`,
  //   url: "/wallet/deposit",

  // }, {
  //   id: "1",
  //   name: "transfer_promo",
  //   mobileName: 'transfer',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer_active.png`,
  //   url: "/wallet/transfer",

  // }, {
  //   id: "2",
  //   name: "withdraw",
  //   mobileName: 'withdraw',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal_active.png`,
  //   url: "/wallet/withdraw",

  // }, {
  //   id: "3",
  //   name: "history",
  //   mobileName: 'history',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_history.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_history_active.png`,
  //   url: "/wallet/history",

  // }],
  my_account: [{
    id: "4",
    name: "user_info",
    mobileName: 'user_info',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo_active.png`,
    url: "/my_account/user_info",

  }, {
    id: "5",
    name: "order_history",
    mobileName: 'order_history',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_orderHistory.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_orderHistory_active.png`,
    url: "/my_account/order_history",

  }]
}

// ---------- DEPOSIT MENU ---------- 

export const DEPOSIT_MENU_DATA = {

  "quickpay": {
    name: "quickpay",
    icon: `${TENANT_BUCKET}/icon/deposit_quickPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_quickPay_active.png`,
  },

  "banktransfer": {
    name: "banktransfer",
    icon: `${TENANT_BUCKET}/icon/deposit_bankTransfer.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_bankTransfer_active.png`,
  },

  "qrpay": {
    name: "qrpay",
    icon: `${TENANT_BUCKET}/icon/deposit_qrPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_qrPay_active.png`,
  },

  "reload": {
    name: "reload",
    icon: `${TENANT_BUCKET}/icon/deposit_reload.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_reload_active.png`,

  }
}

// ---------- DEPOSIT METHOD DATA ----------


export const DEPOSIT_METHOD_DATA = {

  "truepay": {
    name: "truepay",
    label: "Truepay",
  },

  "ipay4u": {
    name: "ipay4u",
    label: "Ipay4u",
  },

  "online_transfer": {
    name: "online_transfer",
    label: "Online Transfer",
  },

  "atm_cash_deposit": {
    name: "atm_cash_deposit",
    label: "ATM Cash Deposit",
  },

  "cash_deposit": {
    name: "cash_deposit",
    label: "Cash Deposit",
  }
}

// ---------- BANK DATA ----------

export const BANK_DATA = {

  "PHBMMYKL": {
    id: "PHBMMYKL",
    name: "Affin Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PHBMMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PHBMMYKL.png`
  },

  "ARBKMYKL": {
    id: "ARBKMYKL",
    name: "Ambank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/ARBKMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/ARBKMYKL.png`
  },

  "BIMBMYKL": {
    id: "BIMBMYKL",
    name: "Bank Islam Malaysia",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BIMBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BIMBMYKL.png`
  },

  "BSNAMYK1": {
    id: "BSNAMYK1",
    name: "Bank Simpanan National",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BSNAMYK1.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BSNAMYK1.png`

  },

  "HLBBMYKL": {
    id: "HLBBMYKL",
    name: "Hong Leong Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/HLBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/HLBBMYKL.png`
  },

  "MBBEMYKL": {
    id: "MBBEMYKL",
    name: "Maybank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/MBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/MBBEMYKL.png`
  },

  "PBBEMYKL": {
    id: "PBBEMYKL",
    name: "Public Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PBBEMYKL.png`
  },

  "RHBBMYKL": {
    id: "RHBBMYKL",
    name: "RHB Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/RHBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/RHBBMYKL.png`
  },

  "CIBBMYKL": {
    id: "CIBBMYKL",
    name: "CIMB Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/CIBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/CIBBMYKL.png`
  },
}

// ---------- QR DATA ----------

export const QR_DATA = {

  "duitnow": {
    id: "duitnow",
    name: "DuitNow QR",
    icon: `${GLOBAL_BUCKET}/qrpay/MYS/duitnow.jpg`,
  },
}

// ---------- TRANSACTION TYPE DATA ----------

export const TRANSACTION_TYPE_DATA = {

  "transfer": {
    name: "transfer",
    url: "/wallet/history/transfer"
  },

  "betting_summary": {
    name: "betting_summary",
    url: "/wallet/history/betting_summary"
  },

  "deposit_withdrawal": {
    name: "deposit_withdrawal",
    url: "/wallet/history/deposit_withdrawal"
  },

  "promotion_apply": {
    name: "promotion_apply",
    url: "/wallet/history/promotion_apply"
  },

  "rebate": {
    name: "rebate",
    url: "/wallet/history/rebate"
  },

  "bonus": {
    name: "bonus",
    url: "/wallet/history/bonus"
  },
}

// ---------- USER VERIFICATION DATA ----------

export const USER_VERIFICATION_DATA = [
  {
    id: "phone_validated",
    name: "phone_number",
    // icon:<FaMobileAlt />,
  },
  {
    id: "email_validated",
    name: "email",
  },
  {
    id: "dob_validated",
    name: "dob",
    // icon: <FaAddressCard />,
  }
]

// ---------- SOCIAL MEDIA DATA ----------

export const SOCIAL_MEDIA_DATA = {

  "LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_chatwithus.png`,
  },

  "TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_telegram.png`,
  },

  "WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_whatsapp.png`,
  },

  "WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_wechat.png`,
  },
  "SIDEBAR_LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_chatwithus.png`,
  },

  "SIDEBAR_TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_telegram.png`,
  },

  "SIDEBAR_WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_whatsapp.png`,
  },

  "SIDEBAR_WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_wechat.png`,
  },


  "TIKTOK": {
    name: "TikTok",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/tiktok.png`,
  },

  "YOUTUBE": {
    name: "YouTube",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/youtube.png`,
  },

  "TWITTER": {
    name: "Twiiter",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/twitter.png`,
  },

  "INSTAGRAM": {
    name: "Instagram",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/instagram.png`,
  },

  "FACEBOOK": {
    name: "Facebook",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/facebook.png`,
  },
}

// ---------- GAME WALLET CATEGORY ----------
export const GAME_WALLET_CATEGORY = [
  ["SL", "LC", "FH", "APP"], ["SB", "ES"], ["CB", "LK", "PK", "MG"]
]

// ---------- HISTORY TABLE FIELD ----------
export const HISTORY_TABLE_FIELD = {

  "TRANSFER": {
    id: "TRANSFER",
    allAttr: ["from", "to", "amount", "transaction_date", "transaction_status"],
    selectedTableColumn: ["transaction_date", "to", "amount", "transaction_status"]
  },

  "BETTING_SUMMARY": {
    id: "BETTING_SUMMARY",
    allAttr: ["game_provider", "bet_count", "bet_amount", "valid_bet_amount", "total_bonus", "total_rebate"],
    selectedTableColumn: ["game_provider", "bet_count", "bet_amount"]
  },

  "DEPOSIT_WITHDRAW": {
    id: "DEPOSIT_WITHDRAW",
    allAttr: ["payment_type", "ticket_id", "amount", "transaction_date", "transaction_status", 'remark'],
    selectedTableColumn: ["paymentType_transactionDate", "amount", "transaction_status"]
  },

  "PROMOTION_APPLY": {
    id: "PROMOTION_APPLY",
    allAttr: ["ticket_id", "promotion_name", "to", "transfer_amount", "promo_bonus_amount", "target_amount", "transaction_date", "transaction_status", 'remark'],
    selectedTableColumn: ["promotion", "transfer_amount", "promo_bonus_amount", "transaction_status"]
  },

  "REBATE": {
    id: "REBATE",
    allAttr: ["release_date", "release_amount", "rebate_start_date", "rebate_end_date", "status"],
    selectedTableColumn: ["release_date", "release_amount", "rebate_start_date", "rebate_end_date", "status"]
  },

  "BONUS": {
    id: "BONUS",
    allAttr: ["from", "to", "amount", "transaction_date", "transaction_status"],
    selectedTableColumn: ["to", "amount", "transaction_status"]
  },
}

export const IMAGE_SIZE_DYNAMIC = {
  '1x1': {
    'desktop': {
      'none': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'right': {
        2: 320,
        3: 240
      },
      'bottom': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'insideImage': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
    },
    'mobile': {
      'none': {
        2: 150,
        3: 150,
        4: 150,
      },
      'right': {
        1: 150,

      },
      'bottom': {
        2: 150,
        3: 150,
        4: 150,
      }, 'insideImage': {
        2: 150,
        3: 150,
        4: 150,
      }
    }
  },
  '1x2': {
    'desktop': {
      'none': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'right': {
        1: 750,
        2: 320
      },
      'bottom': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    },
    'mobile': {
      'none': {
        1: 320,
        2: 320,
        3: 320,
      },
      'right': {
        1: 320,

      },
      'bottom': {
        2: 320,
        3: 320,
        4: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    }
  }
}


// ---------- WALLET MENU ---------- 


// COUNTRY LIST

export const COUNTRY_LIST = [
  { "name": "Afghanistan", "code": "AF", "dial_code": "93" },
  { "name": "Åland Islands", "code": "AX", "dial_code": "358" },
  { "name": "Albania", "code": "AL", "dial_code": "355" },
  { "name": "Algeria", "code": "DZ", "dial_code": "213" },
  { "name": "American Samoa", "code": "AS", "dial_code": "1‑684" },
  { "name": "Andorra", "code": "AD", "dial_code": "376" },
  { "name": "Angola", "code": "AO", "dial_code": "244" },
  { "name": "Anguilla", "code": "AI", "dial_code": "1‑264" },
  { "name": "Antarctica", "code": "AQ", "dial_code": "672" },
  { "name": "Antigua and Barbuda", "code": "AG", "dial_code": "1‑268" },
  { "name": "Argentina", "code": "AR", "dial_code": "54" },
  { "name": "Armenia", "code": "AM", "dial_code": "374" },
  { "name": "Aruba", "code": "AW", "dial_code": "297" },
  { "name": "Australia", "code": "AU", "dial_code": "61" },
  { "name": "Austria", "code": "AT", "dial_code": "43" },
  { "name": "Azerbaijan", "code": "AZ", "dial_code": "994" },
  { "name": "Bahamas (the)", "code": "BS", "dial_code": "1‑242" },
  { "name": "Bahrain", "code": "BH", "dial_code": "973" },
  { "name": "Bangladesh", "code": "BD", "dial_code": "880" },
  { "name": "Barbados", "code": "BB", "dial_code": "1‑246" },
  { "name": "Belarus", "code": "BY", "dial_code": "375" },
  { "name": "Belgium", "code": "BE", "dial_code": "32" },
  { "name": "Belize", "code": "BZ", "dial_code": "501" },
  { "name": "Benin", "code": "BJ", "dial_code": "229" },
  { "name": "Bermuda", "code": "BM", "dial_code": "1‑441" },
  { "name": "Bhutan", "code": "BT", "dial_code": "975" },
  { "name": "Bolivia (Plurinational State of)", "code": "BO", "dial_code": "591" },
  { "name": "Bonaire, Sint Eustatius and Saba", "code": "BQ", "dial_code": "599" },
  { "name": "Bosnia and Herzegovina", "code": "BA", "dial_code": "387" },
  { "name": "Botswana", "code": "BW", "dial_code": "267" },
  { "name": "Bouvet Island", "code": "BV", "dial_code": "" },
  { "name": "Brazil", "code": "BR", "dial_code": "55" },
  { "name": "British Indian Ocean Territory (the)", "code": "IO", "dial_code": "246" },
  { "name": "Brunei Darussalam", "code": "BN", "dial_code": "673" },
  { "name": "Bulgaria", "code": "BG", "dial_code": "359" },
  { "name": "Burkina Faso", "code": "BF", "dial_code": "226" },
  { "name": "Burundi", "code": "BI", "dial_code": "257" },
  { "name": "Canada", "code": "CA", "dial_code": "1" },
  { "name": "Cayman Islands (the)", "code": "KY", "dial_code": "1‑345" },
  { "name": "Central African Republic (the)", "code": "CF", "dial_code": "236" },
  { "name": "Chad", "code": "TD", "dial_code": "235" },
  { "name": "Chile", "code": "CL", "dial_code": "56" },
  { "name": "China", "code": "CN", "dial_code": "86" },
  { "name": "Christmas Island", "code": "CX", "dial_code": "61" },
  { "name": "Cocos (Keeling) Islands (the)", "code": "CC", "dial_code": "61" },
  { "name": "Colombia", "code": "CO", "dial_code": "57" },
  { "name": "Comoros (the)", "code": "KM", "dial_code": "269" },
  { "name": "Congo (the Democratic Republic of the)", "code": "CD", "dial_code": "243" },
  { "name": "Congo (the)", "code": "CG", "dial_code": "242" },
  { "name": "Cook Islands (the)", "code": "CK", "dial_code": "682" },
  { "name": "Costa Rica", "code": "CR", "dial_code": "506" },
  { "name": "Croatia", "code": "HR", "dial_code": "385" },
  { "name": "Cuba", "code": "CU", "dial_code": "53" },
  { "name": "Curaçao", "code": "CW", "dial_code": "599" },
  { "name": "Cyprus", "code": "CY", "dial_code": "357" },
  { "name": "Czechia", "code": "CZ", "dial_code": "420" },
  { "name": "Côte d'Ivoire", "code": "CI", "dial_code": "225" },

  { "name": "Denmark", "code": "DK", "dial_code": "45" },
  { "name": "Djibouti", "code": "DJ", "dial_code": "253" },
  { "name": "Dominica", "code": "DM", "dial_code": "1‑767" },
  { "name": "Dominican Republic (the)", "code": "DO", "dial_code": "1‑809" },

  { "name": "Ecuador", "code": "EC", "dial_code": "593" },
  { "name": "Egypt", "code": "EG", "dial_code": "20" },
  { "name": "El Salvador", "code": "SV", "dial_code": "503" },
  { "name": "Equatorial Guinea", "code": "GQ", "dial_code": "240" },
  { "name": "Eritrea", "code": "ER", "dial_code": "291" },
  { "name": "Estonia", "code": "EE", "dial_code": "372" },
  { "name": "Eswatini", "code": "SZ", "dial_code": "268" },
  { "name": "Ethiopia", "code": "ET", "dial_code": "251" },

  { "name": "Falkland Islands (the) [Malvinas]", "code": "FK", "dial_code": "500" },
  { "name": "Faroe Islands (the)", "code": "FO", "dial_code": "298" },
  { "name": "Fiji", "code": "FJ", "dial_code": "679" },
  { "name": "Finland", "code": "FI", "dial_code": "358" },
  { "name": "France", "code": "FR", "dial_code": "33" },
  { "name": "French Guiana", "code": "GF", "dial_code": "594" },
  { "name": "French Polynesia", "code": "PF", "dial_code": "689" },
  { "name": "French Southern Territories (the)", "code": "TF", "dial_code": "" },

  { "name": "Gabon", "code": "GA", "dial_code": "241" },
  { "name": "Gambia (the)", "code": "GM", "dial_code": "220" },
  { "name": "Georgia", "code": "GE", "dial_code": "995" },
  { "name": "Germany", "code": "DE", "dial_code": "49" },
  { "name": "Ghana", "code": "GH", "dial_code": "233" },
  { "name": "Gibraltar", "code": "GI", "dial_code": "350" },
  { "name": "Greece", "code": "GR", "dial_code": "30" },
  { "name": "Greenland", "code": "GL", "dial_code": "299" },
  { "name": "Grenada", "code": "GD", "dial_code": "1‑473" },
  { "name": "Guadeloupe", "code": "GP", "dial_code": "590" },
  { "name": "Guam", "code": "GU", "dial_code": "1‑671" },
  { "name": "Guatemala", "code": "GT", "dial_code": "502" },
  { "name": "Guernsey", "code": "GG", "dial_code": "44‑1481" },
  { "name": "Guinea", "code": "GN", "dial_code": "224" },
  { "name": "Guinea‑Bissau", "code": "GW", "dial_code": "245" },
  { "name": "Guyana", "code": "GY", "dial_code": "592" },  { "name": "Haiti", "code": "HT", "dial_code": "509" },
  { "name": "Heard Island and McDonald Islands", "code": "HM", "dial_code": "672" },
  { "name": "Holy See (the)", "code": "VA", "dial_code": "379" },
  { "name": "Honduras", "code": "HN", "dial_code": "504" },
  { "name": "Hong Kong", "code": "HK", "dial_code": "852" },
  { "name": "Hungary", "code": "HU", "dial_code": "36" },

  { "name": "Iceland", "code": "IS", "dial_code": "354" },
  { "name": "India", "code": "IN", "dial_code": "91" },
  { "name": "Indonesia", "code": "ID", "dial_code": "62" },
  { "name": "Iran (Islamic Republic of)", "code": "IR", "dial_code": "98" },
  { "name": "Iraq", "code": "IQ", "dial_code": "964" },
  { "name": "Ireland", "code": "IE", "dial_code": "353" },
  { "name": "Isle of Man", "code": "IM", "dial_code": "44‑1624" },
  { "name": "Israel", "code": "IL", "dial_code": "972" },
  { "name": "Italy", "code": "IT", "dial_code": "39" },

  { "name": "Jamaica", "code": "JM", "dial_code": "1‑876" },
  { "name": "Japan", "code": "JP", "dial_code": "81" },
  { "name": "Jersey", "code": "JE", "dial_code": "44‑1534" },
  { "name": "Jordan", "code": "JO", "dial_code": "962" },

  { "name": "Kazakhstan", "code": "KZ", "dial_code": "7" },
  { "name": "Kenya", "code": "KE", "dial_code": "254" },
  { "name": "Kiribati", "code": "KI", "dial_code": "686" },
  { "name": "Korea (the Republic of)", "code": "KR", "dial_code": "82" },
  { "name": "Korea (the Democratic People's Republic of)", "code": "KP", "dial_code": "850" },
  { "name": "Kuwait", "code": "KW", "dial_code": "965" },
  { "name": "Kyrgyzstan", "code": "KG", "dial_code": "996" },

  { "name": "Lao People's Democratic Republic (the)", "code": "LA", "dial_code": "856" },
  { "name": "Latvia", "code": "LV", "dial_code": "371" },
  { "name": "Lebanon", "code": "LB", "dial_code": "961" },
  { "name": "Lesotho", "code": "LS", "dial_code": "266" },
  { "name": "Liberia", "code": "LR", "dial_code": "231" },
  { "name": "Libya", "code": "LY", "dial_code": "218" },
  { "name": "Liechtenstein", "code": "LI", "dial_code": "423" },
  { "name": "Lithuania", "code": "LT", "dial_code": "370" },
  { "name": "Luxembourg", "code": "LU", "dial_code": "352" },

  { "name": "Macao", "code": "MO", "dial_code": "853" },
  { "name": "Madagascar", "code": "MG", "dial_code": "261" },
  { "name": "Malawi", "code": "MW", "dial_code": "265" },
  { "name": "Malaysia", "code": "MY", "dial_code": "60" },
  { "name": "Maldives", "code": "MV", "dial_code": "960" },
  { "name": "Mali", "code": "ML", "dial_code": "223" },
  { "name": "Malta", "code": "MT", "dial_code": "356" },
  { "name": "Marshall Islands (the)", "code": "MH", "dial_code": "692" },
  { "name": "Martinique", "code": "MQ", "dial_code": "596" },
  { "name": "Mauritania", "code": "MR", "dial_code": "222" },
  { "name": "Mauritius", "code": "MU", "dial_code": "230" },
  { "name": "Mayotte", "code": "YT", "dial_code": "262" },
  { "name": "Mexico", "code": "MX", "dial_code": "52" },
  { "name": "Micronesia (Federated States of)", "code": "FM", "dial_code": "691" },
  { "name": "Moldova (the Republic of)", "code": "MD", "dial_code": "373" },
  { "name": "Monaco", "code": "MC", "dial_code": "377" },
  { "name": "Mongolia", "code": "MN", "dial_code": "976" },
  { "name": "Montenegro", "code": "ME", "dial_code": "382" },
  { "name": "Montserrat", "code": "MS", "dial_code": "1‑664" },
  { "name": "Morocco", "code": "MA", "dial_code": "212" },
  { "name": "Mozambique", "code": "MZ", "dial_code": "258" },
  { "name": "Myanmar", "code": "MM", "dial_code": "95" },

  { "name": "Namibia", "code": "NA", "dial_code": "264" },
  { "name": "Nauru", "code": "NR", "dial_code": "674" },
  { "name": "Nepal", "code": "NP", "dial_code": "977" },
  { "name": "Netherlands (the)", "code": "NL", "dial_code": "31" },
  { "name": "New Caledonia", "code": "NC", "dial_code": "687" },
  { "name": "New Zealand", "code": "NZ", "dial_code": "64" },
  { "name": "Nicaragua", "code": "NI", "dial_code": "505" },
  { "name": "Niger (the)", "code": "NE", "dial_code": "227" },
  { "name": "Nigeria", "code": "NG", "dial_code": "234" },
  { "name": "Niue", "code": "NU", "dial_code": "683" },
  { "name": "Norfolk Island", "code": "NF", "dial_code": "672" },
  { "name": "Northern Mariana Islands (the)", "code": "MP", "dial_code": "1‑670" },
  { "name": "Norway", "code": "NO", "dial_code": "47" },

  { "name": "Oman", "code": "OM", "dial_code": "968" },

  { "name": "Pakistan", "code": "PK", "dial_code": "92" },
  { "name": "Palau", "code": "PW", "dial_code": "680" },
  { "name": "Palestine, State of", "code": "PS", "dial_code": "970" },
  { "name": "Panama", "code": "PA", "dial_code": "507" },
  { "name": "Papua New Guinea", "code": "PG", "dial_code": "675" },
  { "name": "Paraguay", "code": "PY", "dial_code": "595" },
  { "name": "Peru", "code": "PE", "dial_code": "51" },
  { "name": "Philippines (the)", "code": "PH", "dial_code": "63" },
  { "name": "Pitcairn", "code": "PN", "dial_code": "64" },
  { "name": "Poland", "code": "PL", "dial_code": "48" },
  { "name": "Portugal", "code": "PT", "dial_code": "351" },
  { "name": "Puerto Rico", "code": "PR", "dial_code": "1‑787" },

  { "name": "Qatar", "code": "QA", "dial_code": "974" },

  { "name": "Republic of North Macedonia", "code": "MK", "dial_code": "389" },
  { "name": "Romania", "code": "RO", "dial_code": "40" },
  { "name": "Russian Federation (the)", "code": "RU", "dial_code": "7" },
  { "name": "Rwanda", "code": "RW", "dial_code": "250" },
  { "name": "Réunion", "code": "RE", "dial_code": "262" },

  { "name": "Saint Barthélemy", "code": "BL", "dial_code": "590" },
  { "name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH", "dial_code": "290" },
  { "name": "Saint Kitts and Nevis", "code": "KN", "dial_code": "1‑869" },
  { "name": "Saint Lucia", "code": "LC", "dial_code": "1‑758" },
  { "name": "Saint Martin (French part)", "code": "MF", "dial_code": "590" },
  { "name": "Saint Pierre and Miquelon", "code": "PM", "dial_code": "508" },
  { "name": "Saint Vincent and the Grenadines", "code": "VC", "dial_code": "1‑784" },
  { "name": "Samoa", "code": "WS", "dial_code": "685" },
  { "name": "San Marino", "code": "SM", "dial_code": "378" },
  { "name": "Sao Tome and Principe", "code": "ST", "dial_code": "239" },
  { "name": "Saudi Arabia", "code": "SA", "dial_code": "966" },
  { "name": "Senegal", "code": "SN", "dial_code": "221" },
  { "name": "Serbia", "code": "RS", "dial_code": "381" },
  { "name": "Seychelles", "code": "SC", "dial_code": "248" },
  { "name": "Sierra Leone", "code": "SL", "dial_code": "232" },
  { "name": "Singapore", "code": "SG", "dial_code": "65" },
  { "name": "Sint Maarten (Dutch part)", "code": "SX", "dial_code": "1‑721" },
  { "name": "Slovakia", "code": "SK", "dial_code": "421" },
  { "name": "Slovenia", "code": "SI", "dial_code": "386" },
  { "name": "Solomon Islands", "code": "SB", "dial_code": "677" },
  { "name": "Somalia", "code": "SO", "dial_code": "252" },
  { "name": "South Africa", "code": "ZA", "dial_code": "27" },
  { "name": "South Georgia and the South Sandwich Islands", "code": "GS", "dial_code": "500" },
  { "name": "South Sudan", "code": "SS", "dial_code": "211" },
  { "name": "Spain", "code": "ES", "dial_code": "34" },
  { "name": "Sri Lanka", "code": "LK", "dial_code": "94" },
  { "name": "Sudan (the)", "code": "SD", "dial_code": "249" },
  { "name": "Suriname", "code": "SR", "dial_code": "597" },
  { "name": "Svalbard and Jan Mayen", "code": "SJ", "dial_code": "47" },
  { "name": "Sweden", "code": "SE", "dial_code": "46" },
  { "name": "Switzerland", "code": "CH", "dial_code": "41" },
  { "name": "Syrian Arab Republic", "code": "SY", "dial_code": "963" },

  { "name": "Taiwan (Province of China)", "code": "TW", "dial_code": "886" },
  { "name": "Tajikistan", "code": "TJ", "dial_code": "992" },
  { "name": "Tanzania, United Republic of", "code": "TZ", "dial_code": "255" },
  { "name": "Thailand", "code": "TH", "dial_code": "66" },
  { "name": "Timor-Leste", "code": "TL", "dial_code": "670" },
  { "name": "Togo", "code": "TG", "dial_code": "228" },
  { "name": "Tokelau", "code": "TK", "dial_code": "690" },
  { "name": "Tonga", "code": "TO", "dial_code": "676" },
  { "name": "Trinidad and Tobago", "code": "TT", "dial_code": "1‑868" },
  { "name": "Tunisia", "code": "TN", "dial_code": "216" },
  { "name": "Turkey", "code": "TR", "dial_code": "90" },
  { "name": "Turkmenistan", "code": "TM", "dial_code": "993" },
  { "name": "Turks and Caicos Islands (the)", "code": "TC", "dial_code": "1‑649" },
  { "name": "Tuvalu", "code": "TV", "dial_code": "688" },

  { "name": "Uganda", "code": "UG", "dial_code": "256" },
  { "name": "Ukraine", "code": "UA", "dial_code": "380" },
  { "name": "United Arab Emirates (the)", "code": "AE", "dial_code": "971" },
  { "name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB", "dial_code": "44" },
  { "name": "United States Minor Outlying Islands (the)", "code": "UM", "dial_code": "1‑684" },
  { "name": "United States of America (the)", "code": "US", "dial_code": "1" },
  { "name": "Uruguay", "code": "UY", "dial_code": "598" },
  { "name": "Uzbekistan", "code": "UZ", "dial_code": "998" },

  { "name": "Vanuatu", "code": "VU", "dial_code": "678" },
  { "name": "Venezuela (Bolivarian Republic of)", "code": "VE", "dial_code": "58" },
  { "name": "Viet Nam", "code": "VN", "dial_code": "84" },
  { "name": "Virgin Islands (British)", "code": "VG", "dial_code": "1‑284" },
  { "name": "Virgin Islands (U.S.)", "code": "VI", "dial_code": "1‑340" },

  { "name": "Wallis and Futuna", "code": "WF", "dial_code": "681" },
  { "name": "Western Sahara", "code": "EH", "dial_code": "212" },
  { "name": "Yemen", "code": "YE", "dial_code": "967" },
  { "name": "Zambia", "code": "ZM", "dial_code": "260" },
  { "name": "Zimbabwe", "code": "ZW", "dial_code": "263" }
];
